import Cookies from "js-cookie"
import { useEffect, useState } from "react"

const AFFIRM_BOOSTRAP_ID = "affirm-script"

const useAffirm = () => {
  const [loaded, setLoaded] = useState(false)
  const cartToken = Cookies.get(sl.config.cookies_config.cart_token)

  useEffect(() => {
    if (
      !sl.config.enable_affirm ||
      !sl.api.affirm?.js_src ||
      !sl.api.affirm?.public_api_key
    ) {
      return
    }

    if (document.getElementById(AFFIRM_BOOSTRAP_ID)) {
      if (window.affirm) {
        window.affirm.ui.ready(() => setLoaded(true))
      }
      return
    }

    const script = document.createElement("script")
    script.id = AFFIRM_BOOSTRAP_ID
    script.innerHTML = `
      var _affirm_config = {
        public_api_key: ${JSON.stringify(sl.api.affirm.public_api_key)},
        script: ${JSON.stringify(sl.api.affirm.js_src)},
        session_id: ${JSON.stringify(cartToken)}
      };

      (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
        !0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady")
    `

    document.body.appendChild(script)

    if (window.affirm) {
      window.affirm.ui.ready(() => setLoaded(true))
    }
  }, [])

  useEffect(() => {
    if (loaded && window.affirm) {
      window.affirm.checkout.set({
        public_api_key: sl.api.affirm.public_api_key,
        session_id: cartToken,
      })
    }
  }, [loaded, cartToken])

  return loaded
}

export default useAffirm
